import * as z from 'zod';

export const TranslateSiteRequest = z.object({
  mainLanguage: z
    .object({
      language: z
        .string()
        .describe('The IETF BCP 47 formatted identifier of the language')
        .optional(),
      flagV2: z.string().max(2).optional().nullable(),
    })
    .describe('Language from which the site content is translated'),
  options: z.object({
    translatedLanguage: z
      .object({
        language: z
          .string()
          .describe('The IETF BCP 47 formatted identifier of the language')
          .optional(),
        flagV2: z.string().max(2).optional().nullable(),
      })
      .describe('Language into which the site content is translated'),
  }),
});
export const TranslateSiteResponse = z.object({});
export const GetSiteTranslatablesPropertiesRequest = z.object({
  mainLanguage: z
    .object({
      language: z
        .string()
        .describe('The IETF BCP 47 formatted identifier of the language')
        .optional(),
      flagV2: z.string().max(2).optional().nullable(),
    })
    .describe('Number of words included in main_language'),
  options: z
    .object({
      translatedLanguage: z
        .object({
          language: z
            .string()
            .describe('The IETF BCP 47 formatted identifier of the language')
            .optional(),
          flagV2: z.string().max(2).optional().nullable(),
        })
        .describe(
          'Number of words already translated from main_language to translated_language'
        )
        .optional(),
    })
    .optional(),
});
export const GetSiteTranslatablesPropertiesResponse = z.object({
  data: z
    .object({
      totalWords: z
        .number()
        .int()
        .describe('Total number of words that exist in the main_language')
        .optional(),
      translatedWords: z
        .number()
        .int()
        .describe(
          'Number of words that were already translated into the translated_language'
        )
        .optional(),
      machineTranslationWordsUsed: z
        .number()
        .int()
        .describe('Word credits already used for machine translation')
        .optional(),
      machineTranslateWordsLimit: z
        .number()
        .int()
        .describe('Word credits available for machine translation')
        .optional(),
      applicationProperties: z
        .array(
          z.object({
            appId: z
              .string()
              .describe('Unique identifier of application ID')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional(),
            applicationTotalWords: z
              .number()
              .int()
              .describe(
                'Total number of words that exist in the main_language in a specific application'
              )
              .optional(),
            applicationTranslatedWords: z
              .number()
              .int()
              .describe(
                'Number of words that were already translated into the translated_language in a specific application'
              )
              .optional(),
          })
        )
        .max(1024)
        .optional(),
    })
    .describe('Current status of site translation and word credits usage')
    .optional(),
});
